/**
 * HOC that checks if the currently logged in user
 * has the necessary roles to view the wrapped
 * component. If not, it redirects to /404.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

import AuthenticationWrapper from './AuthenticationWrapper';
import gate from './gate';

const AuthorizationWrapper = (
  allowedRoles,
  allowedOAuthProvider,
) => WrappedComponent => {
  class WithAuthorization extends React.Component {
    static propTypes = {
      me: PropTypes.shape({
        id: PropTypes.string.isRequired,
        roles: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
          }),
        ),
      }).isRequired,
      currentOAuthProvider: PropTypes.string.isRequired,
    };
    render() {
      const { me, currentOAuthProvider } = this.props;
      if (
        gate.isAllowed({ user: me, allowedRoles }) &&
        (!allowedOAuthProvider || allowedOAuthProvider === currentOAuthProvider)
      ) {
        return <WrappedComponent {...this.props} />;
      }
      return <Redirect to="/404" />;
    }
  }

  return AuthenticationWrapper(WithAuthorization);
};

export default AuthorizationWrapper;
